<template>
  <b-container>
    <b-breadcrumb :items="bread" class="mt10"></b-breadcrumb>
    <b-card
      header="共享航次计划信息管理系统"
      header-tag="header"
      align="center"
      header-class="login-header"
      class="form-background"
    >
      <b-row no-gutters style="padding:20px;">
        <div class="form-style">
          <h3 style="font-weight: bold">注册</h3>

          <b-form @submit="onSubmit" class="mt20">
            <b-form-group id="input-group-1" label="用户名" label-for="input-1" description="登录账号，中文和英文，长度3-10位">
              <b-input-group>
                <b-form-input
                  autocomplete="off"
                  id="input-1"
                  v-model="form.username"
                  @input="usernameChange"
                  required
                  trim
                ></b-form-input>

                <b-input-group-append>
                  <b-button :variant="checkVariant" :disabled="checking" @click="checkUsername">
                    <b-spinner v-if="checking" small style="margin-right:20px"></b-spinner>
                    {{checkContent}}
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>

            <b-form-group id="input-group-2" label="真实姓名" label-for="input-2">
              <b-form-input id="input-2" v-model="form.realName" required autocomplete="off"></b-form-input>
            </b-form-group>

            <b-form-group id="input-group-3" label="密码" label-for="input-2" description="最少6个字符">
              <b-form-input id="input-3" v-model="form.password" required type="password" trim></b-form-input>
            </b-form-group>

            <b-form-group id="input-group-4" label="确认密码" label-for="input-2">
              <b-form-input
                id="input-4"
                :state="invalidPassword"
                v-model="form.password2"
                required
                type="password"
                aria-describedby="input-4-feedback"
                trim
              ></b-form-input>
              <b-form-invalid-feedback id="input-4-feedback">两次输入密码不同</b-form-invalid-feedback>
            </b-form-group>

            <b-form-group id="input-group-5" label="所属单位" label-for="input-2">
              <b-form-input id="input-5" v-model="form.unit" required autocomplete="off"></b-form-input>
            </b-form-group>

            <b-form-group id="input-group-6" label="电子邮箱" label-for="input-2" description="请填写您的常用邮箱，此邮箱用于接收系统下发的各类邮件">
              <b-form-input id="input-6" v-model="form.email" required type="email" autocomplete="off"></b-form-input>
            </b-form-group>

            <b-form-group id="input-group-7" label="手机号" label-for="input-2">
              <b-form-input id="input-7" v-model="form.mobile" required type="tel" autocomplete="off"></b-form-input>
            </b-form-group>

            <b-form-group id="input-group-8" label="备注" label-for="input-2">
              <b-form-textarea id="textarea" v-model="form.remark" placeholder="随便说点什么..." rows="3" max-rows="6"></b-form-textarea>
            </b-form-group>

            <b-row
              style="display:flex;justify-content:space-between; padding:0 20px; font-size:16px;margin-bottom:40px;"
            >
              <div>
                <a href="/findPwd">找回密码</a>
              </div>
              <div>
                已有账号？
                <a href="/login">去登录</a>
              </div>
            </b-row>

            <b-button
              fluid
              block
              type="submit"
              variant="primary"
              style="padding:6px 80px; background-color:#0582bb;border:1px solid #006ea7"
            >
              <b-spinner v-if="commiting" small style="margin-right:20px"></b-spinner>注册
            </b-button>
          </b-form>
        </div>
      </b-row>
    </b-card>
    <!-- LINKS -->
    <link-component class="mt20"></link-component>
  </b-container>
</template>

<script>
import LinkComponent from '../../components/LinkComponent.vue';
import { axiosServer } from '@/api/judge';
import { urls } from '@/api/urls';
import Vue from 'vue';

export default {
  components: { LinkComponent },
  name: 'option',
  props: {},
  computed: {
    invalidPassword() {
      if (this.form.password != this.form.password2) {
        return false;
      } else {
        return true;
      }
    }
  },

  data() {
    return {
      bread: [
        {
          text: '首页',
          href: '/index'
        },
        {
          text: '用户注册'
        }
      ],
      name: '',

      form: {
        email: '',
        name: '',
        food: null,
        checked: []
      },

      checking: false,
      commiting: false,
      checkContent: '检测是否可用',
      checkVariant: 'info'
    };
  },

  mounted() {},

  methods: {
    usernameChange() {
      this.checkContent = '检测是否可用';
      this.checkVariant = 'info';
    },

    checkUsername() {
      this.checking = true;
      axiosServer({
        url: urls.checkUserName,
        type: 'post',
        params: { username: this.form.username }
      })
        .then(resp => {
          this.checking = false;
          if (resp.data.code == 0) {
            if (resp.data.exist) {
              this.checkContent = '已存在，不可用';
              this.checkVariant = 'danger';
            } else {
              this.checkContent = '可以使用';
              this.checkVariant = 'success';
            }
          } else {
            this.checkContent = '检测失败，点击重试';
            this.checkVariant = 'danger';
          }
        })
        .catch(e => {
          this.checkContent = '检测失败，点击重试';
          this.checking = false;
          this.checkVariant = 'danger';
        });
    },

    onSubmit(evt) {
      evt.preventDefault();
      this.commiting = true;
      axiosServer({
        url: urls.register,
        params: this.form,
        type: 'post'
      })
        .then(resp => {
          this.commiting = false;
          if (resp.data.code == 0) {
            this.$bvToast.toast('注册成功', {
              title: '提示',
              toaster: 'b-toaster-top-center',
              solid: true,
              appendToast: true,
              variant: 'success',
              autoHideDelay: '2000'
            });
            this.$nextTick(() => {
              this.$router.push({ name: 'login' });
            });
          } else {
            this.showSubitError(resp.data.msg);
          }
        })
        .catch(() => {
          this.commiting = false;
          this.showSubitError();
        });
    },
    showSubitError(msg) {
      this.$bvToast.toast('注册失败' + msg, {
        title: '提示',
        toaster: 'b-toaster-top-center',
        solid: true,
        appendToast: true,
        variant: 'danger',
        autoHideDelay: '3000'
      });
    }
  }
};
</script>

<style scoped>
.login-header {
  font-size: 20px;
  font-weight: bold;
  color: #115ca5;
}

@media (max-width: 575.99px) {
  .form-style {
    text-align: left;
    width: 100%;
  }

  .botton-row {
    margin-bottom: 20px;
  }
}

@media (min-width: 576px) {
  .form-style {
    text-align: left;
    width: 100%;
  }

  .botton-row {
    margin-bottom: 20px;
  }
}

@media (min-width: 768px) {
  .form-style {
    text-align: left;
    width: 70%;
    margin: 0 auto;
  }

  .botton-row {
    margin-bottom: 20px;
    padding: 0 50px;
  }
}

@media (min-width: 992px) {
  .form-style {
    text-align: left;
    width: 70%;
    margin: 0 auto;
  }

  .botton-row {
    margin-bottom: 20px;
    padding: 0 100px;
  }
}

@media (min-width: 1200px) {
  .form-style {
    text-align: left;
    width: 70%;
    margin: 0 auto;
  }

  .botton-row {
    margin-bottom: 20px;
    padding: 0 200px;
  }
}
</style>
